import React from 'react'
import PropTypes from 'prop-types'
import ErrorBoundary from '../../../../molecules/ErrorBoundary'
import FadeIn from '../../../../molecules/Transitions/FadeIn'
import Loading from '../../../../molecules/Loading'
import OpalHeading from '../../../../opal/OpalHeading'
import JsxAttachment from './attachmentTypes/jsx/JsxAttachment'

function AttachmentDisplay ({ attachment }) {
  if (attachment.contentType === 'application/jsx') {
    return (
      <JsxAttachment attachment={attachment} />
    )
  }

  return (
    <div>Unknown Attachment Type</div>
  )
}

AttachmentDisplay.propTypes = {
  attachment: PropTypes.shape({
    threadMessageAttachmentId: PropTypes.string,
    title: PropTypes.string,
    contentType: PropTypes.string,
    data: PropTypes.any
  })
}

function AttachmentArea ({ attachment, isLoading }) {
  if (isLoading) {
    return (
      <FadeIn className='w-full flex items-center justify-center gap-md'>
        <Loading />
        <OpalHeading className='font-size-lg'>Loading Item</OpalHeading>
      </FadeIn>
    )
  }

  if (!attachment) {
    return (
      <FadeIn className='w-full flex items-center justify-center gap-md font-size-lg' style={{ color: 'var(--color-neutral-500)' }}>
        Chat or select a response item to view preview
      </FadeIn>
    )
  }

  return (
    <ErrorBoundary name='Abundance Designer Preview Area'>
      <FadeIn key={attachment.threadMessageAttachmentId} className='w-full'>
        <AttachmentDisplay attachment={attachment} />
      </FadeIn>
    </ErrorBoundary>
  )
}

AttachmentArea.propTypes = {
  attachment: PropTypes.object,
  isLoading: PropTypes.bool
}

export default AttachmentArea
